import React, { useEffect } from "react";
import BreadcrumbArea from "../components/BreadcrumbArea/BreadcrumbArea";
import ServicesDetailedArea from "../components/ServicesDetailed/ServicesDetailedArea";
import Layout from "../layouts/Layout";
import { gsapTitleAnimation } from "../lib/gsap-lib/gsapTitleAnimation";

const ServicesDetailedPage = () => {
  useEffect(() => {
    gsapTitleAnimation();
  }, []);

  return (
    <Layout header={1} footer={1}>
      <BreadcrumbArea
        title={"Our Services — Renovation, Electrical, Plumbing & Painting in Malaysia"}
        subtitle={"Our Services"}
      />
      <ServicesDetailedArea />
    </Layout>
  );
};

export default ServicesDetailedPage;
